import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateConfig, UpdateConfigRequest, ConfigurationObject } from '../services/configs-api';

interface UpdateConfigParams {
  configId: string;
  body: UpdateConfigRequest;
}

/**
 * TanStack Mutation hook for updating an existing configuration object.
 * Invalidates both the list and individual config cache on success.
 */
export function useUpdateConfig() {
  const queryClient = useQueryClient();

  return useMutation<ConfigurationObject, Error, UpdateConfigParams>({
    mutationFn: ({ configId, body }) => updateConfig(configId, body),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['configs'] });
      queryClient.setQueryData(['configs', data.configId], data);
    },
  });
}
